<template>
  <msisdn :msisdn="this.currentMsisdn"></msisdn>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import Msisdn from '@/components/process/generic/Customer/Msisdn/Msisdn.vue'

export default {
  name: 'CurrentMsisdn',
  components: { Msisdn },
  data () {
    return {
      currentCustomer: null
    }
  },
  computed: {
    currentMsisdn () {
      return this.currentCustomer?.contract?.msisdn
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query currentMsisdn {
 currentCustomer {
   contract {
     msisdn
   }
 }
}`, this, 'currentCustomer'
      )
    }
  }
}
</script>
